import { render, staticRenderFns } from "./DataTableEmpty.vue?vue&type=template&id=dde8cd6c"
import script from "./DataTableEmpty.vue?vue&type=script&lang=js"
export * from "./DataTableEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports